import base from './base.js'
import * as mixin from './mixin.js'
import sdk from './sdk/sdk.js'
import tool from './tool.js'

var app = {
    ...base,
    mixin,
    ...sdk,
    tool,
}

Vue.prototype.app = window.app = app
export default app
